var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRupee(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.02 8.34985H3.59V23.2849H29.02V8.34985Z",
    stroke: "#0067FF",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60999 8.2749C8.61328 8.93361 8.48638 9.58648 8.23658 10.196C7.98678 10.8055 7.61901 11.3597 7.15439 11.8266C6.68977 12.2936 6.13746 12.6641 5.52919 12.9169C4.92093 13.1698 4.2687 13.2999 3.60999 13.2999",
    stroke: "#0067FF",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.755 23.2849C8.74843 21.9609 8.21954 20.6929 7.28328 19.7566C6.34702 18.8204 5.07906 18.2915 3.755 18.2849",
    stroke: "#0067FF",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.08 8.2749C24.08 9.60762 24.6094 10.8857 25.5518 11.8281C26.4941 12.7705 27.7723 13.2999 29.105 13.2999",
    stroke: "#0067FF",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24 23.2849C24.0066 21.9609 24.5355 20.6929 25.4717 19.7566C26.408 18.8204 27.6759 18.2915 29 18.2849",
    stroke: "#0067FF",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.235 11.1499H15.5C16.745 11.1499 18.115 11.5549 18.115 13.4499C18.115 15.5049 16.375 16.2899 14.525 16.0799C14.5031 16.0773 14.481 16.0817 14.4618 16.0924C14.4426 16.103 14.4272 16.1195 14.4178 16.1393C14.4084 16.1592 14.4055 16.1816 14.4095 16.2032C14.4135 16.2248 14.4241 16.2447 14.44 16.2599L18.37 20.4999",
    stroke: "#0067FF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.62 11.1499H15.225",
    stroke: "#0067FF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.295 13.5149H19.65",
    stroke: "#0067FF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRupee);
export default __webpack_public_path__ + "static/media/rupee.209bb5b223457a0afc23d68bca1e5571.svg";
export { ForwardRef as ReactComponent };